import { Route } from 'react-router-dom';
import React from 'react';
import LoginPage from 'LOGIN/Components/LoginPage/LoginPage';
import ForgotPassword from 'LOGIN/Components/ForgotPassword/ForgotPassword';
import RequestAccess from 'LOGIN/Components/RequestAccess/RequestAccess';

class LoginRoutes extends React.Component {
    render() {
        return (
            <>
                <Route path="/login/:instituteUrl" component={LoginPage} />
                <Route path="/forgot-password/:instituteUrl" component={ForgotPassword} />
                <Route path="/access/:instituteUrl/:requestId" component={RequestAccess} />
            </>
        );
    }
}

export default LoginRoutes;